/* Mother of Strays: dynamic storefront MOQ.
 * Source: custom.minimum_order_quantity rendered into data attributes.
 * Customer-facing guard for product pages, Dawn quick-add modals and product-card forms.
 * Checkout-level enforcement still requires a Shopify validation function/app.
 */
(function () {
  function associatedQuantity(form) {
    var input = form.querySelector('input[name="quantity"]');
    if (input || !form.id) return input;
    return document.querySelector('input[name="quantity"][form="' + form.id.replace(/"/g, '\\"') + '"]');
  }

  function addNote(anchor, minimum) {
    if (!anchor || anchor.parentElement.querySelector('[data-mos-moq-note]')) return;
    var note = document.createElement('p');
    note.dataset.mosMoqNote = '';
    note.textContent = 'Minimum ' + minimum + ' per variant';
    note.style.cssText = 'margin:.8rem 0 0;font-size:1.3rem;font-weight:600;line-height:1.35;color:rgba(var(--color-foreground),.72)';
    anchor.insertAdjacentElement('afterend', note);
  }

  function enforceProductForm(form) {
    var owner = form.closest('product-form[data-mos-minimum], [data-mos-minimum]');
    var minimum = Number((owner && owner.dataset.mosMinimum) || form.dataset.mosMinimum || 1);
    if (!Number.isInteger(minimum) || minimum <= 1) return;

    var quantity = associatedQuantity(form);
    if (!quantity) {
      quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.value = String(minimum);
      quantity.dataset.mosMoq = 'true';
      form.appendChild(quantity);
    } else {
      quantity.min = String(minimum);
      quantity.dataset.min = String(minimum);
      quantity.dataset.mosMoq = 'true';
      if (!quantity.value || Number(quantity.value) < minimum) quantity.value = String(minimum);
      addNote(quantity.closest('quantity-input') || quantity, minimum);
    }
  }

  function enforceCartInput(input) {
    var minimum = Number(input.dataset.mosMinimum || 1);
    if (!Number.isInteger(minimum) || minimum <= 1) return;
    input.min = String(minimum);
    input.dataset.min = String(minimum);
    input.dataset.mosMoq = 'true';
    addNote(input.closest('quantity-input') || input, minimum);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form[action*="/cart/add"], product-form form').forEach(enforceProductForm);
    scope.querySelectorAll('input[data-quantity-variant-id]').forEach(enforceCartInput);
    if (root && root.matches) {
      if (root.matches('form[action*="/cart/add"], product-form form')) enforceProductForm(root);
      if (root.matches('input[data-quantity-variant-id]')) enforceCartInput(root);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form');
    if (form) enforceProductForm(form);
  }, true);

  document.addEventListener('change', function (event) {
    var form = event.target.closest('form');
    if (form) enforceProductForm(form);
    if (event.target.matches('input[data-quantity-variant-id]')) enforceCartInput(event.target);
  }, true);

  function start() {
    scan(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
